import styles from "./AppLoadingIndicator.module.scss";

import type { CSSProperties } from "react";

type AppLoadingIndicatorProps = {
  size?: "small" | "medium" | "large";
  color?: string;
};
export const AppLoadingIndicator = ({
  size = "medium",
  color = "currentColor",
}: AppLoadingIndicatorProps) => {
  const cssVars: CSSProperties = { ["--spinner-color" as string]: color };

  return (
    <div
      className={`${styles.ldsSpinner} ${styles[size]}`}
      data-testid="app-loading-indicator"
      style={cssVars}
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
